module.exports = new __parcel__URL__("attachments-preview.7bdfffc6.svg").toString();